export default "__VITE_ASSET__BQT$P50X__"